import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const preSpecifiedTopicAtom = atom(document.getElementById('root')?.getAttribute('topic'));

export const visitedPagesAtom = atomWithStorage<string[]>('visited_pages', []);

export const mutedAtom = atomWithStorage<boolean>('muted', false);
